import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: 20px -20px 0 0;
  height: 480px;

  .jobsList-wrapper {
    padding: 0 20px 0 0;
  }

  .jobsList-noJobs {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 130%;
    color: var(--color-text-muted);
    text-align: center;
    padding: 5px 0 10px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .jobsList-item:last-child {
    margin: 0;
    padding: 0 0 5px;
    border-bottom: none;
  }

  .jobsList-item {
    padding: 0 0 15px;
    margin: 0 0 15px;
    border-bottom: 1px solid var(--color-border);

    &-workspace-wrapper {
      margin: 4px 0 0;
      min-height: 22px;
    }

    &-deadline {
      margin: 6px 0 0;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 150%;
      color: var(--color-text-muted);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &-assignee {
      margin: 10px 0 0;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 150%;
      color: var(--color-text-muted);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;
